






import Vue from 'vue'
import Avatar from '@/components/Avatar/avatar.vue'
import Student from '@/models/Students/Student'
import User from '@/models/Users/User'
import msgrsList from '@/components/Users/Page/msgrsList.vue'

export default Vue.extend({
  name: 'UserMsgrsCol',
  components: {
    msgrsList
  },
  props: {
    row: Object as () => User,
  }
})
